import { Component } from '@angular/core';
import {
  InfoChipColor,
  InfoChipShape,
  InfoChipSize,
  InfoChipType,
} from 'src/app/common-components/info-chip/info-chip.types';
import {
  MunilyAreaCardData,
  MunilyAreaCardImageFit,
  MunilyAreaCardType,
} from 'src/app/common-components/area-card/area-card.types';

@Component({
  selector: 'app-area-card-playground',
  templateUrl: './area-card-playground.component.html',
  styleUrls: ['./area-card-playground.component.scss'],
})
export class AreaCardPlaygroundComponent {
  type: MunilyAreaCardType = 'picture';
  title = 'Area names go here in maximun of two lines';
  description =
    'Area descriptions go here, Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto.';
  capacity = '000';
  chipLabel = 'estado';
  chipColor: InfoChipColor = 'blue';
  chipSize: InfoChipSize = 'small';
  chipShape: InfoChipShape = 'rounded-large';
  chipInfoType: InfoChipType = 'filled';
  rating = '5.0';
  showRating = true;
  showMenuButton = true;

  imageUrl = '';
  imageFit: MunilyAreaCardImageFit = 'cover';

  lastEvent = '';

  readonly types: MunilyAreaCardType[] = ['picture', 'icon'];
  readonly imageFits: MunilyAreaCardImageFit[] = ['cover', 'contain'];
  readonly chipColors: InfoChipColor[] = ['blue', 'green', 'red', 'gray', 'yellow'];
  readonly chipSizes: InfoChipSize[] = ['small', 'large'];
  readonly chipShapes: InfoChipShape[] = ['rounded-large', 'rounded-small'];
  readonly chipInfoTypes: InfoChipType[] = ['filled', 'outline'];

  get data(): MunilyAreaCardData {
    return {
      type: this.type,
      title: this.title,
      description: this.description,
      capacity: this.capacity,
      chip: this.chipLabel
        ? {
            label: this.chipLabel,
            color: this.chipColor,
            size: this.chipSize,
            shape: this.chipShape,
            infoChipType: this.chipInfoType,
          }
        : undefined,
      rating: this.rating,
      showRating: this.showRating,
      showMenuButton: this.showMenuButton,
      imageUrl: this.imageUrl || undefined,
      imageFit: this.imageFit,
    };
  }

  onSelect(): void {
    this.lastEvent = `select @ ${new Date().toLocaleTimeString()}`;
  }

  onMenuClick(): void {
    this.lastEvent = `menuClick @ ${new Date().toLocaleTimeString()}`;
  }
}
